import React, { Component } from "react";
import AppBar from 'material-ui/AppBar';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import "./Login.css";

export default class Login extends Component {

    handleSubmit = event => {
        event.preventDefault();
        this.props.login(event.target.password.value)
    }

    render() {
        return (
            <div className="Login">
                <AppBar style={{backgroundColor: "#5a5598"}} title={<span><img className="banner" src="./img/banner.png" alt="Leaping Libby" /></span>} />
                <form onSubmit={this.handleSubmit}>
                    <TextField
                        className="password"
                        floatingLabelText="Password"
                        floatingLabelFixed={true}
                        fullWidth={true}
                        type="password"
                        name="password"
                    />
                    <RaisedButton fullWidth={true} label="Login" type="submit" />
                </form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Login.js